enum ErrorKey {
    EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND',
    PASSWORD_INCORRECT = 'PASSWORD_INCORRECT',
}

export default ErrorKey;
